export default __webpack_public_path__ + "static/media/number-7.fce554d9.svg";